import { createSelector } from 'reselect';
import { countryTaxTypeDescriptionsSelector } from './selectors';

export const withCTTDescription = selector => createSelector(
  [
    selector,
    countryTaxTypeDescriptionsSelector,
  ],
  (selectorData, countryTaxTypeDescriptions) => selectorData.map(element => ({
    ...element,
    countryTaxTypeDescription: countryTaxTypeDescriptions[element.countryTaxType],
  }))
);
